import PageHighGain from '../components/page-properties'

const Properties = () => <PageHighGain />

Properties.getInitialProps = async() => ({
  namespacesRequired: ['common']
})
export default Properties
